<template>
	<div>
		<template v-if="!canLoadStripe">
			<BAlert variant="light" :model-value="true"
				class="border-danger">
				<h5 class="text-danger">
					Unable to load credit card payment form
				</h5>
				Please report this to
				<a :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>
			</BAlert>
		</template>
		<template v-else>
			<div class="payment-simple">
				<StripeElements
					v-slot="{ elements }"
					ref="stripeElements"
					:stripe-key="stripeKey">
					<div>
						<div class="d-flex justify-content-between align-items-center">
							<label class="col-form-label">Card number</label>
						</div>
						<StripeElement
							id="cardNumber"
							ref="cardElement"
							class="p-2 border rounded mb-4 bg-white"
							type="cardNumber"
							:elements="elements"
							:options="cardOptions">
						</StripeElement>
					</div>
					<div class="d-flex justify-content-between">
						<div class="w-100">
							<label class="col-form-label">Expiration</label>
							<StripeElement
								id="cardExpiry"
								class="p-2 border rounded bg-white"
								type="cardExpiry"
								:elements="elements"
								:options="cardOptions" />
						</div>
						<div class="mx-2"></div>
						<div class="w-100">
							<label class="col-form-label">CVC</label>
							<StripeElement
								id="cardCvc"
								class="p-2 border rounded bg-white"
								type="cardCvc"
								:elements="elements"
								:options="cardOptions" />
						</div>
					</div>
				</StripeElements>
				<BAlert
					v-if="error"
					class="mt-2 mb-0 alert-dismissible"
					variant="danger"
					:model-value="Boolean(error)">
					{{ error.message }}
					<button
						type="button"
						class="close"
						aria-label="Close"
						@click="error = null">
						<span aria-hidden="true">&times;</span>
					</button>
				</BAlert>
			</div>
		</template>
	</div>
</template>

<script>
	import { contactEmail} from '@js/utilities/index.js';
	import { StripeElements, StripeElement } from 'vue-stripe-elements-plus'

	export default {
		components: {
			StripeElements,
			StripeElement,
		},
		props: {
			country: {
				type: String,
				required: true
			}
		},
		data () {
			return {
				contactEmail,
				error: null,
				instanceOptions: {},
				elementsOptions: {},
				cardOptions: {
					appearance: {
						theme: 'night',
						labels: 'floating',
					},
					style: {
						base: {
							fontSize: '16px',
							lineHeight: '24px',
							'::placeholder': {
								color: '#cbd5e1',
							}
						}
					}
				}
			}
		},
		computed: {
			canLoadStripe() {
				return Boolean(this.country && this.stripeKey);
			},
			stripeKey() {
				if (this.isClient) {
					return this.stripeKeyForAustralia;
				}

				if (this.country.startsWith('N')) {
					return this.stripeKeyForNewZealand;
				}

				return this.stripeKeyForAustralia;
			},
			stripeKeyForAustralia() {
				return import.meta.env.VITE_STRIPE_KEY || import.meta.env.MIX_STRIPE_KEY || null;
			},
			stripeKeyForNewZealand() {
				return import.meta.env.VITE_NZ_STRIPE_KEY || import.meta.env.MIX_NZ_STRIPE_KEY || this.stripeKeyForAustralia;
			}
		},
		methods: {
			async createToken () {
				if (!this.canLoadStripe) {
					throw new Error('Unable to load credit card payment form.');
				}

				const groupComponent = this.$refs.stripeElements
				const cardComponent = this.$refs.cardElement

				const cardElement = cardComponent.stripeElement

				return new Promise((resolve, reject) => {
					groupComponent.instance.createToken(cardElement).then(result => {
						if (result.token) {
							resolve(result.token.id);
						} else {
							this.error = result.error;
							reject(result.error);
						}
					}).catch(error => {
						reject(error);
					})
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
  @import '../../../../sass/my/variables';

  #cardNumber, #cardExpiry, #cardCvc {
    border: 1px solid $gray-300 !important;
    border-radius: $border-radius !important;
  }
</style>
